"use strict";

import "../scss/main.scss";

window.$ = window.jQuery = require('jquery');

// import Swiper JS
import Swiper, { Navigation, Autoplay } from 'swiper';

import "./components/navigation.js";

import "./components/accordion.js";

import "./components/cookie-bar.js";

import "./components/download.js";

import "./components/dialog.js";

import "./components/tabs.js";

if (document.querySelector('.directors-slider')) {
  new Swiper('.directors-slider', {
    // Optional parameters
    modules: [Navigation],
    direction: 'horizontal',
    loop: false,
    speed: 400,
    slidesPerView: 3,
    spaceBetween: 24,
    breakpoints: {
      // when window width is >= 0px
      0: {
        slidesPerView: 1,
      },
      // when window width is >= 400px
      400: {
        slidesPerView: 2,
      },
      // when window width is >= 700px
      700: {
        slidesPerView: 3,
      }
    },
    navigation: {
      nextEl: '.swiper-button-directors-next',
      prevEl: '.swiper-button-directors-prev',
    },
  });
}


